import type { TFunction } from "i18next";
import type { SceneNode } from "@uzverse/world-scene";
import { parsePart } from "./focus.js";
import type { WORLD_NS } from "./i18n.js";

type WorldT = TFunction<typeof WORLD_NS>;

/** The part of a hit in words: "north wall", "floor slab", "roof". */
export function describePart(t: WorldT, part: string | undefined): string | null {
  const p = parsePart(part);
  if (!p) return null;
  switch (p.kind) {
    case "wall":
      return p.side ? t(`target.part.wall.${p.side}`) : t("target.part.wallAny");
    case "slab":
      return t("target.part.slab");
    case "roof":
      return t("target.part.roof");
    case "body":
      return t("target.part.body");
  }
}

/**
 * What the user is looking at, in words: "Demo Café · Floor 2 · north wall". The floor shows
 * ordinal text per locale ("2. kat"), the same strings as the side panel.
 */
export function describeTarget(
  t: WorldT,
  node: Pick<SceneNode, "label"> | undefined,
  part: string | undefined,
): string {
  const parts: string[] = [node?.label ?? t("target.unknown")];
  const p = parsePart(part);
  if (p?.level !== undefined) parts.push(t("panel.floorLevel", { level: p.level }));
  const word = describePart(t, part);
  if (word) parts.push(word);
  return parts.join(" · ");
}
